<template>
  <v-btn
    color="#FFFFFF"
    @click="clickAction"
    block
    class="font-weight-bold normal_simple_button"
    elevation="0"
    height="20px"
  >
    <p>{{buttonTitle}}</p>
  </v-btn>
</template>

<script>

export default {
  name: "NormalSimpleButtonSmall",
  data: () => ({
  }),
  methods: {
    clickAction(){
      this.$emit('clickAction');
    }
  },
  components: {
  },
  props: ['buttonTitle']
};

</script>

<style scoped>
.normal_simple_button {
  border-radius: 22px;
  border: 1px solid #ffffff;
}
p {
  margin: 0;
  color: #74b8be;
  font-weight: bold;
  font-size: 0.6em;
}
@media screen and (max-width: 350px) {
}
@media screen and (min-width: 351px) and (max-width: 768px) {
}
@media screen and (min-width: 768px) and (max-width: 1024px) {
}
@media screen and (min-width: 1024px) {
}
</style>
